"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnekFinderContext = exports.SnekFinderProvider = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SnekFinderContext = /*#__PURE__*/React.createContext(undefined);
const defaultInitData = {
  'ae4b3bf8-6ed2-4ac6-bf18-722321af298c': {
    name: 'SF',
    createdAt: '',
    modifiedAt: '',
    isFolder: true,
    childUUIDs: []
  }
};
const SnekFinderProvider = ({
  backend,
  initDataLink,
  rootFileId,
  children
}) => {
  const [initData, setInitData] = React.useState(defaultInitData);
  React.useEffect(() => {
    const fn = async () => {
      let index = await backend.readIndex();
      const storedInitDataLink = localStorage.getItem('initDataLink');
      if (initDataLink) {
        if (!index || storedInitDataLink !== initDataLink) {
          try {
            await backend.downloadIndex(initDataLink);
            localStorage.setItem('initDataLink', initDataLink);
            index = await backend.readIndex();
          } catch {
            console.log('downloadIndex error');
          }
        }
      }
      if (index && JSON.stringify(index) !== JSON.stringify(initData)) {
        setInitData(index);
      }
    };
    fn();
  }, [backend, initDataLink]);
  rootFileId = rootFileId || 'ae4b3bf8-6ed2-4ac6-bf18-722321af298c';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SnekFinderContext.Provider, {
    value: {
      backend,
      initData,
      rootFileId
    },
    children: children
  });
};
exports.SnekFinderProvider = SnekFinderProvider;
const useSnekFinderContext = () => {
  const context = React.useContext(SnekFinderContext);
  if (!context) {
    throw new Error('useSnekFinder must be used within a SnekFinderProvider');
  }
  return context;
};
exports.useSnekFinderContext = useSnekFinderContext;